import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
// import { useHistory } from 'react-router-dom'
// import { api, APIS } from '@/api';
import { Col, DatePicker, Form, Input, InputNumber, message, Row, Select, Spin } from 'antd'
import dayjs from 'dayjs'
import moment from 'moment'
import '../index.less'
// import { numberRegExp, longrg, latreg, numberDecimalRegExp } from '@/pages/estateManage/regular'
import {
  areaFindListByCompanyCodeDetail,
  buildingInfoAddOrUpdate,
  buildingInfoByIdDetail,
  departmentSearchList,
  estateDeveloperSearchList,
  findListByParentCode,
  getBuildingCodeDetail,
  getEnum,
  getAllCompany, findRegionTree, fetchGPList,
} from '@/services/customerServices'
import AMapLoader from '@amap/amap-jsapi-loader'
import copy from 'copy-to-clipboard'
import {getRegionChildren} from "@/services/externalPerson.ts";
import {trimStr} from "@/utils/data.ts";
import {debounce} from "lodash-es";
import {httpCompanyList, httpOrgList} from "@/services/homeService.ts";
import {getDictServer} from "@/services/channelManagement.ts";
import {getUser} from "shj-utils";
const { Option } = Select
const { RangePicker } = DatePicker

export const AddOrEdit = forwardRef((props: any, ref: any) => {
  const userInfo = getUser()

  const numberRegExp: any = /^[1-9]\d*$/
  // 验证正数字小数
  const numberDecimalRegExp: any = /^[+]?(0|([1-9]\d*))(\.\d+)?$/g
  //校验经度
  const longrg: any =
    /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/
  //纬度
  const latreg: any = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/

  const { id, onClose, visibleDrawer }: any = props
  const [constructionStatList, setConstructionStatList] = useState<Array>([]) //立项期楼盘状态
  const [estateDeveloperSelect, setEstateDeveloperList] = useState<Array>([]) //开发商列表
  const [orgCompanyList, setOrgCompanyList] = useState<Array>([]) //楼盘所属区域
  const [orgAreaList, setOrgAreaList] = useState<Array>([]) //所属区域
  const [deptList, setDeptList] = useState<Array>([]) //开发部门
  const [allRemoteConfigureList, setAllRemoteConfigureList] = useState<Array>([]) //远程费标准
  const [remoteFeeTypeList, setRemoteFeeTypeList] = useState<Array>([]) //软装费
  const [provinceCodeList, setProvinceList] = useState<Array>([])
  const [cityCodeList, setCityList] = useState<Array>([])
  const [countyCodeList, setCountyList] = useState<Array>([])
  // const [loading, setLoading] = useState<boolean>(false)
  const [allLoading, setAllLoading] = useState<boolean>(false)
  const [isRequiredRemoteFeeId, setIsRequiredRemoteFeeId] = useState<boolean>(false) //是否必填软程费标准
  const [isRequiredSoftRemoteFee, setIsRequiredSoftRemoteFee] = useState<boolean>(false) //是否必填软程费
  const [buildingCode, setBuildingCode] = useState<any>('')
  const [formData, setFormData] = useState<object>({})
  const [show, setShow] = useState<boolean>(false)

  const [form] = Form.useForm()

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    },
  }
  const formItemLayout2 = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 3 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 21 },
    },
  }
  const formItemLayout3 = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 9 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 15 },
    },
  }
  const reqMeg = '不能为空'

  useEffect(() => {
    if (visibleDrawer) {
      // filterFeeRequired({})
      initSelectData()
      initMap()
      initGetForm()
    }
    return () => {
      setDeptList([])
    }
  }, [visibleDrawer])

  // 1.远程费用填了，远程标准必填 2.远程标准填了，远程费非必填  3.两个都不填
  const filterFeeRequired = (obj: any) => {
    const softRemoteFeeTypeCode_ = false
    let remoteFeeId_ = false
    if (obj.softRemoteFeeTypeCode) {
      remoteFeeId_ = true
    }
    // setIsRequiredSoftRemoteFee(softRemoteFeeTypeCode_)
    // setIsRequiredRemoteFeeId(remoteFeeId_)
  }
  const initMap = () => {
    AMapLoader.load({
      key: '02421fe2279f67b5058bbc78d96f258b', // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '1.4.6', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.ToolBar', 'AMap.Autocomplete', 'AMap.PlaceSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    })
      .then(AMap => {
        const map = new AMap.Map('container6854', {
          resizeEnable: true,
        })
        map.plugin(['AMap.ToolBar', 'AMap.Autocomplete', 'AMap.PlaceSearch'], function () {
          map.addControl(new AMap.Autocomplete())
          const auto = new AMap.Autocomplete({
            input: 'tipInput',
          })
          const placeSearch = new AMap.PlaceSearch({
            map: map,
          }) //构造地点查询类
          AMap.event.addListener(auto, 'select', select) //注册监听，当选中某条记录时会触发
          AMap.event.addListener(placeSearch, 'markerClick', function (e: any) {
            const address_ = e.data.address
            copy(address_)
          })

          function select(e: any) {
            if (e.poi && e.poi.location) {
              // map.setZoom(15);
              // map.setCenter(e.poi.location);
              placeSearch.setCity(e.poi.adcode)
              placeSearch.search(e.poi.name)
            }
          }
        })
        //为地图注册click事件获取鼠标点击出的经纬度坐标
        const clickEventListener = map.on(
          'click',
          function (e: { lnglat: { getLng: () => any; getLat: () => any } }) {
            form.setFieldsValue({
              longitude: e.lnglat.getLng(),
              latitude: e.lnglat.getLat(),
            })
          }
        )
      })
      .catch(e => {})
  }
  // 初始化下拉
  const initSelectData = () => {
    getByParentCode('firstCode', '0', [])
    getEstateDeveloperSelect()
    getOrgCompany()
    // getLoadRemoteFeeType()
    getConstructionStatList()
    getDictServer({key: 'remoteFee'}).then(res =>{
      setAllRemoteConfigureList(res)
    })
  }
  // 默认赋值
  const initGetForm = () => {
    form.resetFields()
    form.setFieldsValue({orgId: userInfo.companyId})
    changeCompanyStatus(userInfo.companyId)
    if (id && id !== '0') {
      buildingInfoById(id)
    } else {
      getBuildingCode()
    }
  }

  const buildingInfoById = (id: string) => {
    setAllLoading(true)

    buildingInfoByIdDetail({ id, flag: false, handlflag: true })
        .then((response: any) => {
          const data = response
          if (data.provinceCode) getByParentCode('provinceCode', data.provinceCode, [])
          if (data.cityCode) getByParentCode('cityCode', data.cityCode, [])
          if (data.orgId) changeCompanyStatus(data.orgId)
          if (data.developStartDate && data.developEndDate) {
            data.developDateTimer = [dayjs(data.developStartDate), dayjs(data.developEndDate)]
          }
          data.handoverDate = data.handoverDate ? dayjs(data.handoverDate) : ''
          data.financialAttr = `${
            data.financialAttr || data.financialAttr == 0 ? data.financialAttr : ''
          }`
          const area = data.areaRange ? data.areaRange.split('~') : []
          data.areaRange1 = area[0] || ''
          data.areaRange2 = area[1] || ''
          // filterFeeRequired(data)

          setFormData(data)
          form.setFieldsValue({
            ...data,
          })
          setAllLoading(false)
        })
        .catch(() => {
          setAllLoading(false)
        })
  }
  // 获取楼盘编码随机数
  const getBuildingCode = () => {
    getBuildingCodeDetail().then((resp: any) => {
      const data = resp
      setBuildingCode(data.buildingCode)
      form.setFieldsValue({
        value: 0,
        buildingCode: data.buildingCode,
        emphasisFlag: 0, // 默认为非重点
      })
    })
  }
  // 获取城市
  const getByParentCode = (codeName: string, parentCode: any, clearCode: string[]) => {
    const formObj = {}
    // 清空
    clearCode.forEach((t: string) => {
      formObj[t] = ''
    })
    form.setFieldsValue({
      ...formObj,
    })
    if (codeName === 'firstCode') {
      findRegionTree().then((response: any) => {
        setProvinceList(response.filter(item => item.object?.level === 'PROVINCE'))
      })
    } else {
      getRegionChildren(parentCode).then((res: any) => {
        codeName === 'provinceCode' ? setCityList(res) : setCountyList(res)
      })
    }
}

  // 获取开发部门
  const getDeptList = (companyCode: any) => {
    Promise.all([
      departmentSearchList({
        companyId: companyCode,
      }),
    ]).then(res => {
      const arr = [...res[0]]
      setDeptList(arr)
    })
  }
  // 获取开发商
  const getEstateDeveloperSelect = () => {
    estateDeveloperSearchList({}).then((response: any) => {
      const estateDeveloperSelectList = response
      setEstateDeveloperList(estateDeveloperSelectList)
    })
  }
  // 获取楼盘所属区域
  const getOrgCompany = () => {
    httpCompanyList().then(response => {
      setOrgCompanyList(response)
    })
  }

  // 获取远程费标准
  /*const getLoadAllRemoteConfigure = (companyCode: any) => {
    // dataDictionary({ parentKey: 'isShjTenant' }).then(res => {
    //   if (res?.length) {
    //     setShow(true)
    //     commonAllRemoteConfigure(companyCode).then((response: any) => {
    //       const list = response || []
    //       setAllRemoteConfigureList(list)
    //     })
    //   }
    // })
    fetchGPList(1, 10, { paramKey: 'remoteFeeFlag' }).then(res => {
      let data = res.list,
          flag = ''
      if (data && data.length > 0) {
        flag = data[0].val === '1' ? true : false
      } else {
        flag = false
      }
      if (flag) {
        setShow(true)
        commonAllRemoteConfigure(companyCode).then((response: any) => {
          const list = response || []
          setAllRemoteConfigureList(list)
        })
      }
    })
  }
  // 软装远程费
  const getLoadRemoteFeeType = () => {
    dataDictionarySearchList({
      parentKey: 'remoteFeeType',
      enable: '1',
    }).then((response: { data: { dictionaryTree: { children: never[] } } }) => {
      const list = response || []
      setRemoteFeeTypeList(list)
    })
  }*/

  // 改变楼盘所属区域联动
  const changeCompanyStatus = (val: any) => {
    setDeptList([])
    form.setFieldsValue({ buildingAreaId: null })
    areaFindListByCompanyCode(val)
    getDeptList(val)
    // getLoadAllRemoteConfigure(val)
  }
  // 根据公司id查询楼盘区域列表
  const areaFindListByCompanyCode = (companyCode: any) => {
    areaFindListByCompanyCodeDetail({ orgId: companyCode, handlflag: false }).then((response: any) => {
      setOrgAreaList(response)
    })
  }
  // 获取立项期楼盘状态
  const getConstructionStatList = () => {
    getEnum('com.shj.saas.plus.crm.domain.building.constants.ConstructionStatEnum').then(
      (resp: any) => {
        setConstructionStatList(resp)
      }
    )
  }
  // 选择所在城市
  const changeCityStatus = (codeName: string, parentCode: any, clearCode: string[]) => {
    if(codeName === 'firstCode'){
      setCityList([])
      setCountyList([])
    }
    getByParentCode(codeName, parentCode, clearCode)
  }

  // 提交
  const onFinish = () => {
    if (props.loading) return;
    props.setLoading?.(true)
    form.validateFields().then(values => {
      const newValues: any = { ...values }
      newValues.handoverDate = newValues.handoverDate
          ? newValues.handoverDate.format('YYYY-MM-DD 00:00:00')
          : ''
      if (newValues.developDateTimer) {
        newValues.developStartDate = newValues.developDateTimer[0].format('YYYY-MM-DD 00:00:00')
        newValues.developEndDate = newValues.developDateTimer[1].format('YYYY-MM-DD 23:59:59')
      }
      newValues.areaRange = `${newValues.areaRange1 || ''}~${newValues.areaRange2 || ''}`
      if (newValues.areaRange1 == '' || newValues.areaRange2 == '') {
        newValues.areaRange = newValues.areaRange.replace('~', '')
      }
      delete newValues.areaRange1
      delete newValues.areaRange2
      delete newValues.developDateTimer
      if (id && id !== '0') {
        newValues.id = id
        buildingInfoAddOrUpdate(newValues, '/updateById')
            .then((response: any) => {
              message.success(response.message || '操作成功', 6)
              onClose && onClose()
              props.setLoading?.(false)
            })
            .catch(() => {
              props.setLoading?.(false)
            })
      } else {
        const url = !props.sceneType ? '' : '/sendBuildFlow'
        buildingInfoAddOrUpdate(newValues, url)
            .then((response: any) => {
              message.success(response.message || '操作成功', 6)
              onClose && onClose()
              props.setLoading?.(false)
            })
            .catch(() => {
              props.setLoading?.(false)
            })
      }
    }).catch(() => props.setLoading?.(false))
  }

  const restForm = () => {
    if (id && id !== '0') {
      form.setFieldsValue({
        value: 0,
        buildingCode: formData.buildingCode,
        emphasisFlag: 0, // 默认为非重点
      })
    } else {
      form.setFieldsValue({
        value: 0,
        buildingCode: buildingCode,
        emphasisFlag: 0, // 默认为非重点
      })
    }
  }
  useImperativeHandle(
    ref,
    () => ({
      onFinish,
      onReset: () => {
        form?.resetFields()
        restForm()
      },
    }),
    [buildingCode, formData, id]
  )

  const onValuesChange = (val: any, all_: any) => {
    filterFeeRequired(all_)
  }
  return (
    <Spin spinning={allLoading}>
      <div style={{padding: '0 5px'}}>
      <Form form={form} onFinish={onFinish} autoComplete="off" onValuesChange={onValuesChange} layout={'vertical'}>
        <Row gutter={42}>
          <Col span={12}>
            <Form.Item  label="楼盘编码" name="buildingCode">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="楼盘名称"
              name="name"
              rules={[{ required: true, message: reqMeg }]}
            >
              <Input allowClear placeholder="请输入楼盘名称" maxLength={20} showCount onChange={(e)=>{form.setFieldValue('name', trimStr(e.target.value))}}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item
              name={'provinceCode'}
              label="所在城市"
              rules={[{ required: true, message: reqMeg }]}
            >
              <Select
                placeholder="请选择"
                onChange={(val: any) => {
                  setCityList([])
                  changeCityStatus('provinceCode', val, ['cityCode', 'countyCode'])
                }}
                showSearch
                allowClear
                filterOption={(input, option: any) => {
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
              >
                {provinceCodeList.map((item: any, index: number) => (
                  <Option key={index + item.object?.regionCode} value={item.object?.regionCode}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'cityCode'} label=" " required={false} rules={[{ required: true, message: reqMeg }]}>
              <Select
                placeholder="请选择"
                onChange={(val: any) => {
                  setCountyList([])
                  changeCityStatus('cityCode', val, ['countyCode'])
                }}
                allowClear
                showSearch
                filterOption={(input, option: any) => {
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
              >
                {cityCodeList.map((item: any, index: number) => (
                  <Option key={index + item.regionCode} value={item.regionCode}>
                    {item.regionName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'countyCode'} label=" " required={false} rules={[{ required: countyCodeList.length > 0, message: reqMeg }]}>
              <Select allowClear placeholder="请选择"  showSearch
                      filterOption={(input, option: any) => {
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }}>
                {countyCodeList.map((item: any, index: number) => (
                  <Option key={index + item.regionCode} value={item.regionCode}>
                    {item.regionName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={42}>
          <Col span={12}>
            <Form.Item  label="楼盘均价" name="price">
              <Input placeholder="请输入楼盘均价" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="交房时间" name="handoverDate" required={true} rules={[{ required: true, message: '不能为空' }]}>
              <DatePicker style={{ width: '100%' }} placeholder={'请选择时间'} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="楼盘面积区间">
              <Row>
                <Col span={11}>
                  <Form.Item
                    noStyle
                    name={'areaRange1'}
                    rules={[
                      {
                        required: false,
                        message: '请验证楼盘面积区间',
                        pattern: numberDecimalRegExp,
                      },
                    ]}
                  >
                    <Input addonAfter="㎡" placeholder="请输入" />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                    ~
                  </span>
                </Col>
                <Col span={11}>
                  <Form.Item
                    noStyle
                    name={'areaRange2'}
                    rules={[{ required: false, message: reqMeg, pattern: numberDecimalRegExp }]}
                  >
                    <Input addonAfter="㎡" placeholder="请输入" />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="开发商" name={'estateDeveloperId'}>
              <Select
                showSearch
                allowClear
                placeholder="请选择开发商"
                filterOption={(input, option: any) => {
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
              >
                {estateDeveloperSelect.map((item: any) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item

              label="楼盘户数"
              name="houseNumber"
              rules={[{ required: true, message: '请输入楼盘户数', pattern: numberRegExp }]}
            >
              <Input allowClear placeholder="请输入楼盘户数" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="是否重点楼盘" name="emphasisFlag">
              <Select allowClear={true} style={{ width: '100%' }} placeholder="选择是否重点楼盘">
                <Option value={0}>非重点</Option>
                <Option value={1}>重点</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="楼盘属性" name="financialAttr">
              <Select allowClear={true} style={{ width: '100%' }} placeholder="选择是楼盘属性">
                <Option value={'1'}>F</Option>
                <Option value={'0'}>非F</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="立项期楼盘状态" name="constructionStat">
              <Select allowClear={true} style={{ width: '100%' }} placeholder="选择立项期楼盘状态">
                {constructionStatList.map((item: any) => (
                  <Option value={item.key} key={item.key}>
                    {item.description}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="签单目标(万元)" name="signingTarget">
              <InputNumber
                min={0}
                precision={4}
                placeholder="请输入签单目标(万元)"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="门店距离(KM)" name="companyDistance">
              <InputNumber
                min={0}
                precision={4}
                placeholder="门店距离(KM)"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={42}>
          <Col span={6}>
            <Form.Item
              name={'orgId'}
              label="楼盘所属区域"
              rules={[{ required: true, message: reqMeg }]}
            >
              <Select
                onChange={(val: any) => {
                  changeCompanyStatus(val)
                }}
                allowClear
                showSearch
                filterOption={(input, option: any) => {
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
                placeholder="请选择"
              >
                {orgCompanyList.map((item: any) => (
                  <Option key={item.orgId} value={item.orgId}>
                    {item.companyName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {show && (
              <>
               {/* <Col span={6}>
                  <Form.Item
                      label="远程费标准"
                      // rules={[{ required: isRequiredRemoteFeeId, message: '请选择' }]}
                      rules={[{ required: false, message: '请选择' }]}
                      name="remoteFeeId"
                  >
                    <Select
                        allowClear
                        placeholder="请选择远程费标准"
                        onChange={(val, option) => {
                          const obj_ = {
                            softRemoteFeeTypeCode:
                                option.key && allRemoteConfigureList[option.key].type,
                          }
                          filterFeeRequired(obj_)
                          form.setFieldsValue(obj_)
                        }}
                    >
                      {allRemoteConfigureList.map((item: any, index: number) => (
                          <Option key={index} value={item.id}>
                            {`${item.typeName}(${item.standardFee})`}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>*/}
                {/*<Col span={6}>
                  <Form.Item

                      label="软装远程费"
                      rules={[{ required: isRequiredSoftRemoteFee, message: '请选择' }]}
                      name="softRemoteFeeTypeCode"
                  >
                    <Select allowClear placeholder="请选择软装远程费">
                      {remoteFeeTypeList.map((item: any) => (
                          <Option key={item.key} value={item.key}>
                            {item.name}
                          </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>*/}
              </>
          )}
          <Col span={6}>
            <Form.Item name={'buildingAreaId'} label={' '} required={false} rules={[{ required: true, message: reqMeg }]}>
              <Select allowClear placeholder="请选择"   showSearch
                      filterOption={(input, option: any) => {
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }}>
                {orgAreaList.map((item: any) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
                label="远程费标准"
                required
                rules={[{ required: true, message: reqMeg }]}
                name="remoteFeeKey"
            >
              <Select
                  allowClear
                  placeholder="请选择远程费标准"
                  onChange={(val, option) => {
                    const obj_ = {
                      softRemoteFeeTypeCode:
                          option.key && allRemoteConfigureList[option.key].type,
                    }
                    filterFeeRequired(obj_)
                    form.setFieldsValue(obj_)
                  }}
              >
                {allRemoteConfigureList.map((item: any, index: number) => (
                    <Option key={index} value={item.priKey}>
                      {item.name}
                    </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={15}>
          <Col span={24}>
            <Form.Item
              label="楼盘地址"
              name="address"
              rules={[{ required: true, message: reqMeg }]}
            >
              <Input placeholder="请输入楼盘地址" maxLength={200} showCount />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item

              label="经度"
              name="longitude"
              rules={[{ required: false, message: '请验证经度', pattern: longrg }]}
            >
              <Input allowClear placeholder="请输入经度" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item

              label="纬度"
              name="latitude"
              rules={[{ required: false, message: '请验证纬度', pattern: latreg }]}
            >
              <Input allowClear placeholder="请输入纬度" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="主力面积" name="mainArea">
              <InputNumber
                min={0}
                precision={4}
                placeholder="请输入主力面积"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="开发起止时间" name="developDateTimer">
              <RangePicker
                style={{ width: '100%' }}
                onChange={(val: any) => {
                  let day: any = ''
                  if (val.length) {
                    day = moment(val[1]).diff(moment(val[0]), 'day') + 1
                  }
                  form.setFieldsValue({
                    developTotalDates: day,
                  })
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="开发周期" name="developTotalDates">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="深耕费用计划合计" name="plannedCosts">
              <InputNumber
                min={0}
                precision={4}
                placeholder="请输入深耕费用计划合计"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item  label="开发部门" name="developDeptCode">
              <Select placeholder="选择开发部门" allowClear={true} showSearch optionFilterProp={'departmentName'} options={deptList} fieldNames={{label: 'departmentName', value: 'id'}}>

              </Select>
            </Form.Item>
          </Col>
          <Col span={24} style={{ position: 'relative', padding: '0 40px', marginBottom: '20px' }}>
            <div id="container666" style={{ position: 'absolute', right: 0, top: 0, zIndex: 999 }}>
              <input type="text" placeholder="请输入关键字进行搜索" id="tipInput" />
            </div>
            <div id="container6854" style={{ height: '500px', overflow: 'hidden' }}></div>
          </Col>
        </Row>
        {/* <Form.Item>
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                保存
              </Button>
            </Col>
          </Row>
        </Form.Item> */}
      </Form>
      </div>
    </Spin>
  )
})
export default AddOrEdit
